import React from "react";
import { Sparkles, TrendingUp, AlertTriangle, Award, Target, DollarSign, Route, Calendar } from "lucide-react";

export default function AICareerInsightsCard({ insights }) {
  if (!insights) return null;
  return (
    <div className="space-y-4" data-testid="portfolio-career-insights-card">
      <div className="glass-panel rounded-2xl p-5 border border-indigo-400/20">
        <p className="text-sm text-slate-300 leading-relaxed" data-testid="career-insights-summary">{insights.ai_career_summary}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <InsightBlock icon={TrendingUp} color="text-emerald-400" label="Strength Areas" items={insights.strength_areas} testid="career-insights-strengths" />
        <InsightBlock icon={AlertTriangle} color="text-amber-400" label="Weak Areas" items={insights.weak_areas} testid="career-insights-weak-areas" />
        <InsightBlock icon={Award} color="text-purple-300" label="Recommended Certifications" items={insights.recommended_certifications} testid="career-insights-certs" />
        <InsightBlock icon={Target} color="text-indigo-300" label="Next Learning Path" items={insights.next_learning_path} testid="career-insights-path" />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <MiniStat icon={Sparkles} label="Learning Style" value={insights.learning_style} testid="career-insights-learning-style" />
        <MiniStat icon={Award} label="Best Skill" value={insights.best_performing_skill} testid="career-insights-best-skill" />
        <MiniStat icon={Route} label="Career Path" value={insights.recommended_career_path} testid="career-insights-career-path" />
        <MiniStat icon={DollarSign} label="Salary Range" value={insights.salary_range} testid="career-insights-salary" />
      </div>

      <div className="glass-panel rounded-xl p-4 flex items-center gap-3" data-testid="career-insights-next-goal">
        <Calendar className="w-4 h-4 text-indigo-400 shrink-0" />
        <div>
          <p className="text-xs font-semibold text-white">{insights.next_learning_goal}</p>
          <p className="text-[11px] text-slate-400">Estimated job readiness: {insights.estimated_job_readiness_date}</p>
        </div>
      </div>
    </div>
  );
}

function InsightBlock({ icon: Icon, color, label, items, testid }) {
  return (
    <div className="glass-panel rounded-xl p-4" data-testid={testid}>
      <p className={`text-[11px] font-bold uppercase tracking-wider ${color} flex items-center gap-1.5 mb-2`}><Icon className="w-3.5 h-3.5" /> {label}</p>
      <ul className="space-y-1">{(items || []).map((s, i) => <li key={i} className="text-xs text-slate-400">• {s}</li>)}</ul>
    </div>
  );
}

function MiniStat({ icon: Icon, label, value, testid }) {
  return (
    <div className="glass-panel rounded-xl p-3.5" data-testid={testid}>
      <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 flex items-center gap-1"><Icon className="w-3 h-3" /> {label}</p>
      <p className="text-xs font-semibold text-white mt-1.5 leading-tight">{value}</p>
    </div>
  );
}
